import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  rowContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20,
  },
}));
